import React from 'react';
import Button from 'components/DesignSystem/Button';
import Accordion from 'components/Accordion';
import { useSelector } from 'react-redux';
import { selectMeteorologyAgroWBSequentialDVTriggerRequest } from 'redux/reducers/meteorologyAgroWBSequentialDVReducer';
import useClearControlPanel from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useClearControlPanel';
import useParams from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useParams';
import Location from './Location';
import Period from './Period';
import Soil from './Soil';
import Group from './Group';

export default function WBSequentialControlPanel() {
  const clearControlPanel = useClearControlPanel();
  const params = useParams();
  const triggerDisabled = !params;
  const onTriggerClick = useSelector(selectMeteorologyAgroWBSequentialDVTriggerRequest);

  return (
    <>
      <Accordion defaultActiveKey="0">
        <Group />
        <Location />
        <Period />
        <Soil />
      </Accordion>
      <Button
        className="w-100 mt-5"
        onClick={onTriggerClick}
        disabled={triggerDisabled}
      >
        Realizar consulta
      </Button>
      <Button
        type="secondary"
        className="w-100 mt-1"
        onClick={clearControlPanel}
      >
        Limpar filtros
      </Button>
    </>
  );
}
